import { InjectionToken } from '@angular/core';

export const CONSENT_APPROVAL_PATH = new InjectionToken<unknown[]>('CONSENT_APPROVAL_PATH');
